import React from 'react'

const Briefcase = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="240"
    height="216"
    fill="none"
    viewBox="0 0 240 216"
    {...props}
  >
    <path
      fill="currentColor"
      d="M216 48h-36V24c0-13.255-10.745-24-24-24H84C70.745 0 60 10.745 60 24v24H24C10.745 48 0 58.745 0 72v120c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V72c0-13.255-10.745-24-24-24zm-72 84c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12v-6a6 6 0 016-6h36a6 6 0 016 6v6zm12-84H84V24h72v24z"
    />
  </svg>
)

export default Briefcase
